/* Volcanic Supplements — front-end interactions */
(function () {
  'use strict';

  /* ---- Sticky header: transparent → solid on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      var scrolled = window.scrollY > 40;
      header.classList.toggle('site-header--solid', scrolled);
      header.classList.toggle('site-header--transparent', !scrolled);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Scroll reveal animations ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Mobile navigation drawer ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  var closeBtn = document.querySelector('[data-drawer-close]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (toggle) toggle.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
  }

  /* ---- Testimonial carousel controls ---- */
  var track = document.querySelector('[data-testi-track]');
  if (track) {
    var prev = document.querySelector('[data-testi-prev]');
    var next = document.querySelector('[data-testi-next]');
    var step = function () {
      var card = track.querySelector('.testi-card');
      return card ? card.offsetWidth + 24 : 360;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  /* The flavor swatch/label sync used to live here. It now belongs to
     initFlavorSelect() in product.js, alongside the swatch dropdown that owns
     the same elements — two scripts writing one dot is a race. */

  /* ---- Hero product rotator ----
     Cycles the hero image through products in a random order and keeps the
     shop button pointed at whichever one is showing. Lives in global.js, not
     product.js, because product.js only loads on the product template. */
  var rotator = document.querySelector('[data-hero-rotator]');
  if (rotator) {
    var slides = Array.prototype.slice.call(rotator.querySelectorAll('[data-hero-slide]'));
    // One product is not a cycle; leave the server-rendered slide alone.
    if (slides.length > 1) {
      var heroLink = rotator.querySelector('[data-hero-link]');
      var heroName = rotator.querySelector('[data-hero-name]');
      var heroPrice = rotator.querySelector('[data-hero-price]');
      var heroDelay = parseInt(rotator.getAttribute('data-interval'), 10) || 5000;
      var heroTimer = null;
      var stillMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Fisher-Yates, so the run order differs every visit rather than always
      // walking the collection front to back.
      var order = slides.map(function (_, i) { return i; });
      for (var oi = order.length - 1; oi > 0; oi--) {
        var oj = Math.floor(Math.random() * (oi + 1));
        var tmp = order[oi];
        order[oi] = order[oj];
        order[oj] = tmp;
      }

      var pos = 0;

      var paint = function (index) {
        var slide = slides[index];
        if (!slide) return;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        if (heroLink) heroLink.href = slide.getAttribute('data-url');
        if (heroName) heroName.textContent = slide.getAttribute('data-title');
        if (heroPrice) heroPrice.textContent = slide.getAttribute('data-price');
      };

      var advance = function (step) {
        pos = (pos + step + order.length) % order.length;
        paint(order[pos]);
      };

      var startHero = function () {
        if (heroTimer || stillMotion) return;
        heroTimer = window.setInterval(function () { advance(1); }, heroDelay);
      };
      var stopHero = function () {
        if (!heroTimer) return;
        window.clearInterval(heroTimer);
        heroTimer = null;
      };

      // Land on a random product immediately rather than always product #1.
      paint(order[0]);
      startHero();

      /* Holding still while the visitor is hovering or tabbing through matters
         more than it looks: the button's href changes on every tick, so a
         rotation mid-click would send them to the wrong product. */
      rotator.addEventListener('mouseenter', stopHero);
      rotator.addEventListener('mouseleave', startHero);
      rotator.addEventListener('focusin', stopHero);
      rotator.addEventListener('focusout', startHero);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopHero(); else startHero();
      });
    }
  }

  /* ---- Wishlist toggle (client-side, localStorage) ---- */
  var WKEY = 'volcanic_wishlist';
  function getWish() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function setWish(list) { localStorage.setItem(WKEY, JSON.stringify(list)); }
  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    var id = btn.getAttribute('data-wishlist');
    if (getWish().indexOf(id) !== -1) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var list = getWish();
      var i = list.indexOf(id);
      if (i === -1) { list.push(id); btn.classList.add('is-active'); }
      else { list.splice(i, 1); btn.classList.remove('is-active'); }
      setWish(list);
    });
  });

  /* ---- Deals popup ---- */
  var deals = document.querySelector('[data-deals]');
  if (deals) {
    var openDeals = function () { deals.hidden = false; };
    var closeDeals = function () { deals.hidden = true; try { localStorage.setItem('volcanic_deals_seen', '1'); } catch (e) {} };
    // Open from any link pointing at #deals
    document.querySelectorAll('a[href="#deals"], a[href$="#deals"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDeals(); });
    });
    deals.querySelectorAll('[data-deals-close]').forEach(function (el) {
      el.addEventListener('click', closeDeals);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDeals(); });
    // Reopen automatically after a successful signup so the code is visible
    if (window.location.search.indexOf('customer_posted=true') !== -1 && deals.querySelector('.deals__code')) {
      openDeals();
    } else {
      // Show once per visitor after a short delay
      var seen = false;
      try { seen = localStorage.getItem('volcanic_deals_seen') === '1'; } catch (e) {}
      if (!seen) { setTimeout(openDeals, 6000); }
    }
  }

  /* ---- AJAX add-to-cart with live count update ---- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      }).catch(function () {});
  }
  updateCartCount();

  document.querySelectorAll('form[data-cart-form], form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Only intercept the quick "add to cart" buttons, not full product forms without JS need
      if (!form.hasAttribute('data-ajax')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartCount();
          if (btn) { btn.innerHTML = 'Added ✓'; setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1400); }
        })
        .catch(function () { if (btn) { btn.innerHTML = original; btn.disabled = false; } });
    });
  });
})();
